// extracted by mini-css-extract-plugin
module.exports = {"vehiclesBlock":"Vehicles_vehiclesBlock__8SaD6","title":"Vehicles_title__KnH7b","description":"Vehicles_description__dLKPG","cardsGrid":"Vehicles_cardsGrid__1t0yE"};